import React from 'react'

import Wrapper from '../../components/Wrapper'
import Content from "../../components/Content";

import Slide from "./Slide";

export default ({children}) => (
  <Wrapper>
    <Slide>
      <Content>{children}</Content>
    </Slide>
  </Wrapper>
)